import {ApiComm} from "../comm";
import {ResponseDTO} from "../dto/ResponseDTO";
import { NoobookFileInfoDTO } from "../dto/CommonDTOs";
import {genNoobookHeader} from "./Common";
import _ from "lodash";
import { BookcommunityBookInfoDTO, BookcommunityBookInputReqDTO
    , BookcommunityInfoDTO,
     BookcommunityInputReqDTO, BookcommunityBookCommentDTO
     , BookcommunityBookCommentInputReqDTO, BookcommunityBookLikeDTO
     , BookcommunityApplicantInfoDTO, BookcommunityBoardTextDTO, BookcommunityBoardTextInputReqDTO, BookcommunityBoardTextLikeDTO, BookcommunityBoardTextReportDTO} from "../dto/BookcommunityDTOs";
import { ActivityType, CommunityApplicantStatus } from "../common/enums";
import { UserInfoDTO } from "../dto/UserDTOs";


   



export function getSearchHashtags(authToken:string):Promise<ResponseDTO<String[]>>
{
    return ApiComm.getData<ResponseDTO<String[]>>(`/close/v1/bookcommunity/searchHashtags`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function uploadBookCommunityImageToTmpFile(authToken:string, file:File):Promise<ResponseDTO<NoobookFileInfoDTO>>
{
    return ApiComm.postFormData<ResponseDTO<NoobookFileInfoDTO>>(`/close/v1/bookcommunity/image`
        , {file:file}
        , genNoobookHeader(authToken, null, 'multipart/form-data', "app")
    ).then(resp=>resp.data);
}

export function getMyBookcommunities(authToken:string, activityType: ActivityType):Promise<ResponseDTO<BookcommunityInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookcommunityInfoDTO[]>>(`/close/v1/bookcommunity/user/me/bookcommunities`
        , {activityType:activityType}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function getPopularBookcommunities(authToken:string, page:number, size:number):Promise<ResponseDTO<BookcommunityInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookcommunityInfoDTO[]>>(`/close/v1/bookcommunity/hashtag/bookcommunities`
        , {page:page, size:size, sort:["total_count,desc","bc.created_at,desc"]}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function getNewBookcommunities(authToken:string, page:number, size:number):Promise<ResponseDTO<BookcommunityInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookcommunityInfoDTO[]>>(`/close/v1/bookcommunity/hashtag/bookcommunities`
        , {page:page, size:size, sort:["bc.created_at,desc"]}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function findBookcommunityByHashtag(authToken:string, hashtag:string, recruitToFr:Date, recruitToTo:Date, page:number, size:number):Promise<ResponseDTO<BookcommunityInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookcommunityInfoDTO[]>>(`/close/v1/bookcommunity/hashtag/bookcommunities`
        , {hashtag:hashtag, recruitToFr:recruitToFr, recruitToTo:recruitToTo, page:page, size:size, sort:"bc.created_at,desc"}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

	
export function createBookcommunity(authToken:string, reqDto:BookcommunityInputReqDTO):Promise<ResponseDTO<BookcommunityInfoDTO>>
{
    return ApiComm.postData<ResponseDTO<BookcommunityInfoDTO>>(`/close/v1/bookcommunity`
        , reqDto
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function modifyBookcommunity(authToken:string, bookcommunityId:number, reqDto:BookcommunityInputReqDTO):Promise<ResponseDTO<BookcommunityInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<BookcommunityInfoDTO>>(`/close/v1/bookcommunity/${bookcommunityId}`
        , reqDto
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


/*@DeleteMapping("/{bookcommunityId}")
	public BookcommunityInfoDTO deleteBookcommunity(@UserAccount UserAccountDTO loginUser, @PathVariable("bookcommunityId") long bookcommunityId) throws NoobookBaseException {
		return this.bookcommunityService.deleteBookcommunity(loginUser.getUserId(), bookcommunityId);
	}
	 */

export function deleteBookcommunity(authToken:string, bookcommunityId:number):Promise<ResponseDTO<BookcommunityInfoDTO>>
{
    return ApiComm.deleteData<ResponseDTO<BookcommunityInfoDTO>>(`/close/v1/bookcommunity/${bookcommunityId}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

	
export function getBookcommunity(authToken:string, bookcommunityId:number):Promise<ResponseDTO<BookcommunityInfoDTO>>
{
    return ApiComm.getData<ResponseDTO<BookcommunityInfoDTO>>(`/close/v1/bookcommunity/${bookcommunityId}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function getBookcommunityBooks(authToken:string, bookcommunityId:number, page:number, size:number, sortByNew:boolean):Promise<ResponseDTO<BookcommunityBookInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookcommunityBookInfoDTO[]>>(`/close/v1/bookcommunity/${bookcommunityId}/books`
        , {page:page, size:size, sort:sortByNew ? "createdAt,desc" : "createdAt,asc"}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}
	
export function getBookcommunityBook(authToken:string, bookcommunityBookId:number): Promise<ResponseDTO<BookcommunityBookInfoDTO>>
{
    return ApiComm.getData<ResponseDTO<BookcommunityBookInfoDTO>>(`/close/v1/bookcommunity/book/${bookcommunityBookId}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function createBookcommunityBook(authToken:string, bookcommunityId:number, bookInputReqDTO:BookcommunityBookInputReqDTO):Promise<ResponseDTO<BookcommunityBookInfoDTO>>
{
    return ApiComm.postData<ResponseDTO<BookcommunityBookInfoDTO>>(`/close/v1/bookcommunity/${bookcommunityId}/book`
        , bookInputReqDTO
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}           
	
	
export function modifyBookcommunityBook(authToken:string, bookcommunityBookId:number, bookInputReqDTO:BookcommunityBookInputReqDTO):Promise<ResponseDTO<BookcommunityBookInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<BookcommunityBookInfoDTO>>(`/close/v1/bookcommunity/book/${bookcommunityBookId}`
        , bookInputReqDTO
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function deleteBookcommunityBook(authToken:string, bookcommunityBookId:number):Promise<ResponseDTO<BookcommunityBookInfoDTO>>
{
    return ApiComm.deleteData<ResponseDTO<BookcommunityBookInfoDTO>>(`/close/v1/bookcommunity/book/${bookcommunityBookId}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function getBookcommunityBookComments(authToken:string, bookcommunityBookId:number, page:number, size:number):Promise<ResponseDTO<BookcommunityBookCommentDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookcommunityBookCommentDTO[]>>(`/close/v1/bookcommunity/book/${bookcommunityBookId}/comments`
        , {sort:["createdAt,desc"], page:page, size:size}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}
	
export function createBookcommunityBookComment(authToken:string, bookcommunityBookId:number, commentInputReqDTO:BookcommunityBookCommentInputReqDTO):Promise<ResponseDTO<BookcommunityBookCommentDTO>>
{
    return ApiComm.postData<ResponseDTO<BookcommunityBookCommentDTO>>(`/close/v1/bookcommunity/book/${bookcommunityBookId}/comment`
        , commentInputReqDTO
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}
	
	
export function modifyBookcommunityBookComment(authToken:string, bookcommunityBookCommentId:number, commentInputReqDTO:BookcommunityBookCommentInputReqDTO):Promise<ResponseDTO<BookcommunityBookCommentDTO>>
{
    return ApiComm.putData<ResponseDTO<BookcommunityBookCommentDTO>>(`/close/v1/bookcommunity/book/comment/${bookcommunityBookCommentId}`
        , commentInputReqDTO
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function deleteBookcommunityBookComment(authToken:string, bookcommunityBookCommentId:number):Promise<ResponseDTO<BookcommunityBookCommentDTO>>
{
    return ApiComm.deleteData<ResponseDTO<BookcommunityBookCommentDTO>>(`/close/v1/bookcommunity/book/comment/${bookcommunityBookCommentId}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function getBookcommunityLikedBookIds(authToken:string, bookcommunityId:number):Promise<ResponseDTO<number[]>>
{
    return ApiComm.getData<ResponseDTO<number[]>>(`/close/v1/bookcommunity/${bookcommunityId}/like/bookIds`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function addBookcommunityBookLike(authToken:string, bookcommunityBookId:number):Promise<ResponseDTO<BookcommunityBookLikeDTO>>
{
    return ApiComm.postData<ResponseDTO<BookcommunityBookLikeDTO>>(`/close/v1/bookcommunity/book/${bookcommunityBookId}/like`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

	

	
export function deleteBookcommunityBookLike(authToken:string, bookcommunityBookId:number):Promise<ResponseDTO<BookcommunityBookLikeDTO>>
{
    return ApiComm.deleteData<ResponseDTO<BookcommunityBookLikeDTO>>(`/close/v1/bookcommunity/book/${bookcommunityBookId}/like`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}



export function getBookcommunityApplicant(authToken:string, bookcommunityId:number):Promise<ResponseDTO<BookcommunityApplicantInfoDTO>>
{
    return ApiComm.getData<ResponseDTO<BookcommunityApplicantInfoDTO>>(`/close/v1/bookcommunity/${bookcommunityId}/applicant`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function getBookcommunityApplicants(authToken:string, bookcommunityId:number, loginid:string, name:string, email:string, applicantStatus:CommunityApplicantStatus, page:number, size:number):Promise<ResponseDTO<BookcommunityApplicantInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookcommunityApplicantInfoDTO[]>>(`/close/v1/bookcommunity/${bookcommunityId}/applicants`
        , { sort: ["applicantStatus,asc", "createdAt,desc"], loginid:loginid || undefined, name:name || undefined, email:email || undefined, applicantStatus:applicantStatus || undefined , page:page, size:size}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function getBookcommunityMembers(authToken:string, bookcommunityId:number, page:number, size:number):Promise<ResponseDTO<UserInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<UserInfoDTO[]>>(`/close/v1/bookcommunity/${bookcommunityId}/members`
        , {page:page, size:size}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function applyToBookcommunity(authToken:string, bookcommunityId:number):Promise<ResponseDTO<BookcommunityApplicantInfoDTO>>
{
    return ApiComm.postData<ResponseDTO<BookcommunityApplicantInfoDTO>>(`/close/v1/bookcommunity/${bookcommunityId}/applicant`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}



export function cancelToBookcommunity(authToken:string, bookcommunityId:number):Promise<ResponseDTO<BookcommunityApplicantInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<BookcommunityApplicantInfoDTO>>(`/close/v1/bookcommunity/${bookcommunityId}/applicant/cancel`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function withdrawToBookcommunity(authToken:string, bookcommunityId:number):Promise<ResponseDTO<BookcommunityApplicantInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<BookcommunityApplicantInfoDTO>>(`/close/v1/bookcommunity/${bookcommunityId}/applicant/withdraw`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function approveToBookcommunity(authToken:string, applicantId:number, bookcommunityId:number):Promise<ResponseDTO<BookcommunityApplicantInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<BookcommunityApplicantInfoDTO>>(`/close/v1/bookcommunity/${bookcommunityId}/applicant/${applicantId}/approve`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function rejectToBookcommunity(authToken:string, applicantId:number, bookcommunityId:number):Promise<ResponseDTO<BookcommunityApplicantInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<BookcommunityApplicantInfoDTO>>(`/close/v1/bookcommunity/${bookcommunityId}/applicant/${applicantId}/reject`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function getBookcommunityDefaultBoardTexts(authToken:string, bookcommunityId:number, page:number, size:number, sortByNew:boolean):Promise<ResponseDTO<BookcommunityBoardTextDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookcommunityBoardTextDTO[]>>(`/close/v1/bookcommunity/${bookcommunityId}/board/default/texts`
        , {page:page, size:size, sort:sortByNew ? "createdAt,desc" : "createdAt,asc"}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function getBookcommunityDefaultBoardText(authToken:string, bookcommunityBoardTextId:number):Promise<ResponseDTO<BookcommunityBoardTextDTO>>
{
    return ApiComm.getData<ResponseDTO<BookcommunityBoardTextDTO>>(`/close/v1/bookcommunity/board/default/text/${bookcommunityBoardTextId}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function createBookcommunityDefaultBoardText(authToken:string, bookcommunityId:number, boardTextInputReqDTO:BookcommunityBoardTextInputReqDTO):Promise<ResponseDTO<BookcommunityBoardTextDTO>>
{
    return ApiComm.postData<ResponseDTO<BookcommunityBoardTextDTO>>(`/close/v1/bookcommunity/${bookcommunityId}/board/default/text`
        , boardTextInputReqDTO
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}



export function modifyBookcommunityDefaultBoardText(authToken:string, bookcommunityBoardTextId:number, boardTextInputReqDTO:BookcommunityBoardTextInputReqDTO):Promise<ResponseDTO<BookcommunityBoardTextDTO>>
{
    return ApiComm.putData<ResponseDTO<BookcommunityBoardTextDTO>>(`/close/v1/bookcommunity/board/default/text/${bookcommunityBoardTextId}`
        , boardTextInputReqDTO
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function deleteBookcommunityDefaultBoardText(authToken:string, bookcommunityBoardTextId:number):Promise<ResponseDTO<BookcommunityBoardTextDTO>>
{
    return ApiComm.deleteData<ResponseDTO<BookcommunityBoardTextDTO>>(`/close/v1/bookcommunity/board/default/text/${bookcommunityBoardTextId}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function getBookcommunityDefaultBoardTextComments(authToken:string, bookcommunityBoardTextId:number):Promise<ResponseDTO<BookcommunityBoardTextDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookcommunityBoardTextDTO[]>>(`/close/v1/bookcommunity/board/default/text/${bookcommunityBoardTextId}/comments`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function createBookcommunityDefaultBoardTextComment(authToken:string, bookcommunityBoardTextId:number, boardTextInputReqDTO:BookcommunityBoardTextInputReqDTO):Promise<ResponseDTO<BookcommunityBoardTextDTO>>
{
    return ApiComm.postData<ResponseDTO<BookcommunityBoardTextDTO>>(`/close/v1/bookcommunity/board/default/text/${bookcommunityBoardTextId}/comment`
        , boardTextInputReqDTO
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function modifyBookcommunityDefaultBoardTextComment(authToken:string, bookcommunityBoardTextCommentId:number, boardTextInputReqDTO:BookcommunityBoardTextInputReqDTO):Promise<ResponseDTO<BookcommunityBoardTextDTO>>
{
    return ApiComm.putData<ResponseDTO<BookcommunityBoardTextDTO>>(`/close/v1/bookcommunity/board/default/text/comment/${bookcommunityBoardTextCommentId}`
        , boardTextInputReqDTO
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function deleteBookcommunityDefaultBoardTextComment(authToken:string, bookcommunityBoardTextCommentId:number):Promise<ResponseDTO<BookcommunityBoardTextDTO>>
{
    return ApiComm.deleteData<ResponseDTO<BookcommunityBoardTextDTO>>(`/close/v1/bookcommunity/board/default/text/comment/${bookcommunityBoardTextCommentId}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function getBookcommunityLikedBoardTextIds(authToken:string, bookcommunityId:number):Promise<ResponseDTO<number[]>>
{
    return ApiComm.getData<ResponseDTO<number[]>>(`/close/v1/bookcommunity/${bookcommunityId}/board/default/like/textIds`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}



export function addBookcommunityBoardTextLike(authToken:string, bookcommunityBoardTextId:number):Promise<ResponseDTO<BookcommunityBoardTextLikeDTO>>
{
    return ApiComm.postData<ResponseDTO<BookcommunityBoardTextLikeDTO>>(`/close/v1/bookcommunity/board/default/text/${bookcommunityBoardTextId}/like`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function deleteBookcommunityBoardTextLike(authToken:string, bookcommunityBoardTextId:number):Promise<ResponseDTO<BookcommunityBoardTextLikeDTO>>
{
    return ApiComm.deleteData<ResponseDTO<BookcommunityBoardTextLikeDTO>>(`/close/v1/bookcommunity/board/default/text/${bookcommunityBoardTextId}/like`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function addBookcommunityBoardTextReport(authToken:string, bookcommunityBoardTextId:number, boardTextReport:string):Promise<ResponseDTO<BookcommunityBoardTextReportDTO>>
{
    //alert(boardTextReport)
    return ApiComm.postData<ResponseDTO<BookcommunityBoardTextReportDTO>>(`/close/v1/bookcommunity/board/default/text/${bookcommunityBoardTextId}/report`
        , boardTextReport
        , genNoobookHeader(authToken, null, 'text/plain', "app")
    ).then(resp=>resp.data);
}

export function deleteBookcommunityBoardTextReport(authToken:string, bookcommunityBoardTextId:number):Promise<ResponseDTO<BookcommunityBoardTextReportDTO>>
{
    return ApiComm.deleteData<ResponseDTO<BookcommunityBoardTextReportDTO>>(`/close/v1/bookcommunity/board/default/text/${bookcommunityBoardTextId}/report`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function getBookcommunityBoardTextReport(authToken:string, bookcommunityBoardTextId:number):Promise<ResponseDTO<BookcommunityBoardTextReportDTO>>
{
    return ApiComm.getData<ResponseDTO<BookcommunityBoardTextReportDTO>>(`/close/v1/bookcommunity/board/default/text/${bookcommunityBoardTextId}/report`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}
